
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Drawer from 'vux/src/components/drawer/index.vue'

import { mapState, mapMutations, mapActions } from 'vuex'

export default {
components: {
ViewBox,
XHeader,
Tabbar,
TabbarItem,
Drawer,
},
data: function () {
return {
showHeader: true,
drawerOpen: false,
}
},
computed: {
...mapState('settings', ['language']),
...mapState('ai', ['messages']),
route() {
return this.$route
},
},
methods: {
...mapMutations('settings', ['setValue']),
...mapActions('settings', ['readCookies']),
showMessages: function () {
this.drawerOpen = !this.drawerOpen
},
},
watch: {
language(newValue) {
this.$i18n.locale = newValue
},
},
created() {
this.readCookies()
if (!this.language) {
this.setValue({ key: 'language', value: this.$i18n.locale })
} else {
this.$i18n.locale = this.language
}
},
mounted() {
let _this = this
window.onresize = function () {

_this.$store.commit('setScreenSize', {
width: document.documentElement.clientWidth,
height: document.documentElement.clientHeight,
})
}
},
}
